(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("gvhyt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $882e65ac256e7310$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $7saNu = parcelRequire("7saNu");

var $dTCkE = parcelRequire("dTCkE");

const $882e65ac256e7310$var$RekaiContent = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("1JiSC")));
const $882e65ac256e7310$var$Rekai = ()=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
        fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $7saNu.default), {}),
        children: /*#__PURE__*/ (0, $a9eYm.jsx)($882e65ac256e7310$var$RekaiContent, {})
    });
};
var $882e65ac256e7310$export$2e2bcd8739ae039 = $882e65ac256e7310$var$Rekai;

});
parcelRegister("7saNu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02159af96205ba56$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $02159af96205ba56$var$RekaiFallback = ()=>{
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "max-w-[1200px] mx-auto lg:px-5 relative",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "mdplus:mx-0",
                children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                    className: "flex overflow-scroll no-scrollbar lg:overflow-hidden my-4 font-icb text-black500",
                    children: [
                        /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            className: "text-lg mdplus:text-xl mr-1 text-blue700 underline flex-shrink-0",
                            children: "Popul\xe4ra bost\xe4der"
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            className: "text-lg mdplus:text-xl ml-3 mdplus:ml-5 mr-1 flex-shrink-0",
                            children: "Njut av din fritid"
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            className: "text-lg mdplus:text-xl ml-3 mdplus:ml-5 mr-1 flex-shrink-0",
                            children: "Dr\xf6mvillan"
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            className: "text-lg mdplus:text-xl ml-3 mdplus:ml-5 mr-1 flex-shrink-0",
                            children: "Stadsk\xe4nsla"
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            className: "text-lg mdplus:text-xl ml-3 mdplus:ml-5 pr-18 flex-shrink-0",
                            children: "Bra energiklass"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: "swiper-wrapper overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "pb-8",
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            className: "swiper-slide !h-[347px] items-start !w-[322px] lg:!w-[320px] mr-4 rounded-md overflow-hidden bg-grey50"
                        })
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "pb-8",
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            className: "swiper-slide !h-[347px] items-start !w-[322px] lg:!w-[320px] mr-4 rounded-md overflow-hidden bg-grey50"
                        })
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "pb-8",
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            className: "swiper-slide !h-[347px] items-start !w-[322px] lg:!w-[320px] mr-4 rounded-md overflow-hidden bg-grey50"
                        })
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "pb-8",
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            className: "swiper-slide !h-[347px] items-start !w-[322px] lg:!w-[320px] mr-4 rounded-md overflow-hidden bg-grey50"
                        })
                    })
                ]
            })
        ]
    });
};
var $02159af96205ba56$export$2e2bcd8739ae039 = $02159af96205ba56$var$RekaiFallback;

});

parcelRegister("1JiSC", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("4WKMi"))((parcelRequire("i55FY")).resolve("7dmS0")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("ZGrDd"))
]).then(()=>parcelRequire("1zEmT"));

});


})();
//# sourceMappingURL=Rekai.55ed75bd.js.map
